import type { Testimonial } from '../types/content'

export const shortTestimonials: Testimonial[] = [
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'High School Program',
    text: 'Instead of spending hours deciding what to teach, I can choose the area we need to improve and already have a complete practice structure ready to follow.',
  },
  {
    initials: 'WI',
    name: 'Wrestling Instructor',
    role: 'Youth Club',
    text: 'The situational wrestling and progression structure make it much easier to connect technique with what athletes actually experience during matches.',
  },
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'Competitive Team',
    text: 'Having developing and advanced options inside the same system makes practice planning much easier when athletes are at different levels.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'Head Coach, High School Program',
    text: 'The biggest difference is not having to invent every practice. I can start with a complete session and spend my time coaching instead of trying to build everything from scratch.',
  },
  {
    initials: 'WI',
    name: 'Wrestling Instructor',
    role: 'Youth Development Club',
    text: 'The amount of variety makes it much easier to avoid repeating the same drills every week.',
  },
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'Club Program Director',
    text: "The progression is what makes the system useful. It isn't just drills—it shows what should come before and after them.",
  },
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'Competition Team Coach',
    text: 'The competition material makes it easier to train the exact situations athletes struggle with during real matches.',
  },
  {
    initials: 'WI',
    name: 'Wrestling Instructor',
    role: 'Mixed-Level Training Group',
    text: "Having developing and advanced adaptations means I can use the same coaching focus with athletes who aren't all at the same level.",
  },
  {
    initials: 'WC',
    name: 'Wrestling Coach',
    role: 'Assistant Coach, Varsity',
    text: 'The bonus drill library is the kind of resource you keep coming back to when you need a different way to reinforce the same skill.',
  },
]
